import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.css']
})
export class DialogConfirmComponent implements OnInit {

  inputValue: string = '';

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.inputValue = this.data.inputValue || '';
  }

  onConfirm(): void {
    if (this.data.requireInput || this.data.inputRequired) {
      this.dialogRef.close({
        confirmed: true,
        inputValue: this.inputValue
      });
    } else {
      this.dialogRef.close({ confirmed: true });
    }
  }
}
